import { createClient } from '@supabase/supabase-js';
import { logger } from '../utils/logger';

// Supabase configuration - use environment variables or fallback to existing project
export const supabaseUrl =
  process.env.REACT_APP_SUPABASE_URL || 'https://qugfnwqynnmbaxfbhjyt.supabase.co';
export const supabaseAnonKey =
  process.env.REACT_APP_SUPABASE_ANON_KEY ||
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InF1Z2Zud3F5bm5tYmF4ZmJoanl0Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTU4ODcyMzUsImV4cCI6MjA3MTQ2MzIzNX0.592SYVR2EBFANIpgx1g6mLTFbA-5hT7TbLgJzO1VGgw';

logger.debug('🔧 Supabase Configuration:', 'URL:', supabaseUrl, 'Anon Key exists:', !!supabaseAnonKey);

// Validate configuration
if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase configuration. Please check your environment variables.');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
  },
  db: {
    schema: 'public'
  }
  // Let Supabase handle headers automatically
})

// TEMPORARILY DISABLED: Service role client not available in frontend
// TODO: Move to backend when implementing server-side operations
// export const supabaseAdmin = createClient(
//   supabaseUrl,
//   process.env.SUPABASE_SERVICE_ROLE_KEY!,
//   {
//     auth: {
//       autoRefreshToken: false,
//       persistSession: false
//     }
//   }
// )
